import { render } from "./ApplicantDetails.vue?vue&type=template&id=b5abdfd8&scoped=true"
import script from "./ApplicantDetails.vue?vue&type=script&lang=js"
export * from "./ApplicantDetails.vue?vue&type=script&lang=js"

import "./ApplicantDetails.vue?vue&type=style&index=0&id=b5abdfd8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5abdfd8"]])

export default __exports__